import { BehaviorSubject, Observable } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";

interface TabsManagerTabItem {
    name: string;
}

class TabsManager {
    tabs: TabsManagerTabItem[] = [];
    _openedTab$ = new BehaviorSubject<null | string>(null);
    openedTab$: Observable<null | string> = this._openedTab$.pipe(
        distinctUntilChanged()
    );

    registerTab(name: string): void {
        this.tabs.push({
            name,
        });
        if (this.tabs.length === 1) {
            this.openTab(name);
        }
    }

    openTab(name: string): void {
        this._openedTab$.next(name);
    }
}

export default TabsManager;
